export const apiHost = process.env.VUE_APP_API_HOST;
export const googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY;
